export const calculatePosition = (
  anchor: any,
  size: any,
  sheetRef: any,
  setSheetStyles: any
) => {
  if (anchor && anchor.current && sheetRef.current) {
    const anchorRect = anchor.current.getBoundingClientRect();
    const viewportWidth = window.innerWidth;
    const viewportHeight = window.innerHeight;
    const sheetWidth = size === 'compact' ? 250 : size === 'medium' ? 340 : 250;
    const margin = 16;
    const maxSheetHeight = viewportHeight - 2 * margin;
    const sheetHeight = sheetRef.current.scrollHeight;

    const spaceAbove = anchorRect.top - margin;
    const spaceBelow = viewportHeight - anchorRect.bottom - margin;

    let top = anchorRect.bottom + window.scrollY;
    let maxHeight = spaceBelow;
    let transformOrigin = "top center";
    let translateY = "0";

    if (sheetHeight <= spaceBelow) {
      maxHeight = spaceBelow;
    } else if (sheetHeight <= spaceAbove) {
      top = anchorRect.top + window.scrollY;
      maxHeight = spaceAbove;
      transformOrigin = "50% 0%";
      translateY = "-100%";
    } else {
      top = Math.max(margin + window.scrollY, anchorRect.top + window.scrollY - (sheetHeight - spaceBelow));
      maxHeight = maxSheetHeight;
      transformOrigin = "center";
      translateY = "0";
    }

    const centerLeft = anchorRect.left + anchorRect.width / 2 - sheetWidth / 2 + window.scrollX;
    const constrainedLeft = Math.max(margin, Math.min(centerLeft, viewportWidth - sheetWidth - margin));

    setSheetStyles({
      top,
      left: constrainedLeft,
      maxHeight,
      transformOrigin,
      translateY,
    });
  }
};

